import type { ShirtColor, ShirtCut } from '../types';
import { COLOR_META } from '../shop/colors';

type ShirtProps = {
  color?: ShirtColor;
  cut?: ShirtCut;
};

export function Shirt({ color = 'czarna', cut = 'męski' }: ShirtProps) {
  const { swatch: bg, stroke, logoFilter } = COLOR_META[color];
  const isFemale = cut === 'damski';
  return (
    <svg viewBox="0 0 220 240" style={{ width: '100%', height: '100%', display: 'block' }}>
      {isFemale ? (
        <path
          d="M48,30 L72,18 Q110,38 148,18 L172,30 L196,55 L178,80 L162,68 L162,120 Q150,140 150,170 L155,210 L65,210 L70,170 Q70,140 58,120 L58,68 L42,80 L24,55 Z"
          fill={bg}
          stroke={stroke}
          strokeWidth="2.5"
        />
      ) : (
        <path
          d="M44,28 L70,16 Q110,40 150,16 L176,28 L200,55 L180,80 L162,68 L162,212 L58,212 L58,68 L40,80 L20,55 Z"
          fill={bg}
          stroke={stroke}
          strokeWidth="2.5"
        />
      )}
      {isFemale ? (
        <path d="M85,18 Q110,40 135,18" fill="none" stroke={stroke} strokeWidth="2" />
      ) : (
        <path d="M82,16 Q110,30 138,16" fill="none" stroke={stroke} strokeWidth="2" />
      )}
      <g transform={`translate(110, ${isFemale ? 110 : 120}) scale(${isFemale ? 0.62 : 0.68})`}>
        <image
          x="-60"
          y="-60"
          width="120"
          height="120"
          href="/logo.png"
          preserveAspectRatio="xMidYMid meet"
          style={{ filter: logoFilter }}
        />
      </g>
    </svg>
  );
}
